import script from "./Comments.vue?vue&type=script&setup=true&lang=js"
export * from "./Comments.vue?vue&type=script&setup=true&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=0ac85d74&lang=css"

const __exports__ = script;

export default __exports__